import {
    Box,
    Button,
    Typography,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useMemo } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useLanguage } from "../../context/LanguageContext";

gsap.registerPlugin(ScrollTrigger);

export const NewAssts = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
    const containerRef = useRef(null);
    const cardRefs = useRef([]);
    const { language, translations } = useLanguage();

    const cards = useMemo(
        () => [
            {
                title: "Usage of MetaTrader 5",
                description:
                    "Harness a full suite of analytic power—fundamental and technical analysis, real-time trading signals, and cutting-edge algorithms—to elevate every trade. Plus, stay in the loop with live financial news broadcasts, so you’re always ahead of market moves. ",
                des: "Tap into expert strategies effortlessly: with MT5’s trading signals and copy-trading, you can mirror top traders’ moves—automatically replicating their orders and tactics in your own account.",
                theme: "light",
            },
        ],
        [translations, language]
    );

    return (
        <Box
            ref={containerRef}
            sx={{
                // pt: { xs: 5, md: 18 },
                overflow: "hidden",
                position: "relative",
                // height: "100vh",
            }}
        >
            <Box>
                {/* Header */}


                {/* Scroll Cards */}
                <Box
                    sx={{
                        position: "relative",
                        height: isSmallScreen ? "auto" : "80vh", // ✅ Fix here
                    }}
                >
                    {cards.map((card, i) => (
                        <Box
                            key={i}
                            ref={(el) => (cardRefs.current[i] = el)}
                            sx={{
                                position: isSmallScreen
                                    ? "relative"
                                    : i === 0
                                        ? "relative" // ✅ Always keep first card relative
                                        : "absolute",
                                // position: isSmallScreen
                                //   ? "relative"
                                //   : i === 0
                                //     ? "relative"
                                //     : "absolute",

                                top: { xs: 20, sm: 30, md: 50 },
                                left: 0,
                                width: "100%",
                                px: { xs: 1, sm: 2, md: 3 },
                            }}
                        >
                            <Box sx={{ transition: "padding-top 0.4s ease" }}>
                                <Box
                                    className="card-inner"
                                    sx={{
                                        width: "100%",
                                        maxWidth: {
                                            xs: "100%",
                                            sm: i === 1 ? "95%" : "90%",
                                            md: i === 1 ? "98%" : "95%",
                                            lg: i === 1 ? "1540px" : "1350px",
                                        },
                                        height: {
                                            xs: "auto",
                                            sm: "400px",
                                            md: "450px",
                                            lg: "600px",
                                        },
                                        marginTop: { xs: 4, sm: 2, md: 0 },
                                        minHeight: { xs: "350px", sm: "610px", md: "420px" },
                                        borderRadius: "25px",
                                        overflow: "hidden",
                                        backgroundColor:
                                            card.theme === "dark" ? "#000000" : "#F3F5F7",
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" },
                                        gap: { xs: 1, sm: 2, md: 3 },
                                        mx: "auto",
                                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                        marginBottom:'20px'
                                    }}
                                >
                                    {/* Text Section */}
                                    <Box
                                        sx={{
                                            flex: 1,
                                            color: card.theme === "dark" ? "#fff" : "#000",
                                            px: { xs: 2, sm: 3, md: 4, lg: 5 },
                                            pt: { xs: 2.5, sm: 3, md: 4, lg: 5 },
                                            pb: { xs: 2, sm: 2.5, md: 3 },
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 700,
                                                color: 'rgba(26, 28, 30, 1)',
                                                fontSize: {
                                                    xs: "28px",
                                                    sm: "28px",
                                                    md: "28px",
                                                    lg: "30px",
                                                    xl: "36px",
                                                },
                                                mb: { xs: 1.5, sm: 2 },
                                            }}
                                        >
                                            Mobile trading and <Box
                                                component="span"
                                                sx={{
                                                    background:
                                                        "linear-gradient(93.28deg, #04A7E5 2.71%, #0382B3 34.19%, #2C8EC2 66.31%)",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                MetaTrader 5
                                            </Box>
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{
                                                fontSize: { xs: "0.9375rem", md: "1.0625rem" }, // 15px and 17px
                                                mt: 2,
                                                fontWeight: 500,
                                                width: "100%",
                                                maxWidth: 460,
                                                textAlign: { xs: "justify", md: "left" },
                                                "@media (max-width:1024px)": {
                                                    maxWidth: 400, // ✅ apply only at or below 1024px
                                                },
                                            }}
                                        >
                                            The trading terminal is not just for Windows, macOS and Linux powered
                                            desktops. Traders with busy schedules can also perform{" "}
                                            <Box
                                                component="a"
                                                href="https://www.exness.com/metatrader-5-app/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    color: "#1794e6",
                                                    fontWeight: 500,
                                                    textDecoration: "none",
                                                    "&:hover": {
                                                        textDecoration: "underline",
                                                    },
                                                }}
                                            >
                                                mobile trading
                                            </Box>{" "}
                                            on their iOS and Android smartphones and tablets. Equipped with all
                                            the integral trading tools, including trading orders, interactive
                                            charts and popular analytical tools, you can monitor your account and
                                            perform mobile trading in a single click.
                                        </Typography>

                                    </Box>

                                    <Box
                                        sx={{
                                            position: "relative", // Required for absolute positioning inside
                                            flex: { xs: 1, md: 2 },
                                            m: { xs: 1, sm: 1.5, md: 0.5 },
                                            backgroundImage: "url(/Images/bluesky.png)",
                                            backgroundSize: "cover",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            borderRadius: "20px",
                                            height: {
                                                xs: "calc(100% - 32px)",
                                                sm: "calc(100% - 48px)",
                                                md: "calc(100% - 8px)",
                                            },
                                            minHeight: {
                                                xs: "200px",
                                                sm: "120px",
                                                md: "160px",
                                            },
                                        }}
                                    >
                                        {/* Centered overlay image */}
                                        <Box
                                            component="img"
                                            src="/Images/updateCorp.png"
                                            alt="Overlay"
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                right: 0, // align to the right
                                                transform: "translateY(-50%)", // center vertically
                                                width: { xs: "70%", md: "80%" },
                                                height: "auto",
                                                maxHeight: { xs: "100%", md: "100%" },
                                                objectFit: "contain",
                                                zIndex: 1,
                                            }}
                                        />
                                        {/* <Box
                                            component="img"
                                            src="/Images/updateCorp.png"
                                            alt="Overlay"
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "65%",
                                                transform: "translate(-31%, -50%)",
                                                width: { xs: "70%", md: "80%" },  // Only set width
                                                height: { xs: "70%", md: "83%" }, // Let height adjust automatically
                                                objectFit: "contain", // Prevent distortion
                                            }}
                                        /> */}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};
